import React, { useState } from 'react';
import { authApi } from '../services/api';

export function SettingsPage() {
  const [agentToken, setAgentToken] = useState<string | null>(null);
  const [deviceName, setDeviceName] = useState('');
  const [generating, setGenerating] = useState(false);

  const handleGenerateToken = async () => {
    setGenerating(true);
    try {
      const result = await authApi.generateAgentToken(deviceName || 'Desktop Agent');
      setAgentToken(result.token);
    } catch (e) {
      alert('Error al generar el token');
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Configuración</h1>
          <p className="page-subtitle">Gestión del sistema AccioTrack</p>
        </div>
      </div>

      {/* Agent Token */}
      <div className="card" style={{ maxWidth: 600 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>🔑 Token para el agente de escritorio</h3>
        <p style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 16, lineHeight: 1.6 }}>
          Genera un token para instalar AccioTrack Desktop en un equipo sin necesidad de contraseña.
          El token es válido durante 1 año.
        </p>

        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <input
            className="input"
            placeholder="Nombre del dispositivo (ej: PC Mariam)"
            value={deviceName}
            onChange={e => setDeviceName(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={handleGenerateToken}
            disabled={generating}
            style={{ whiteSpace: 'nowrap' }}
          >
            {generating ? '...' : 'Generar token'}
          </button>
        </div>

        {agentToken && (
          <div style={{
            background: 'var(--bg3)',
            border: '1px solid var(--border)',
            borderRadius: 8,
            padding: '12px 14px',
          }}>
            <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>
              ⚠️ Copia este token ahora. No se mostrará de nuevo.
            </div>
            <code style={{
              display: 'block',
              fontSize: 12,
              color: 'var(--accent)',
              wordBreak: 'break-all',
              lineHeight: 1.6,
            }}>
              {agentToken}
            </code>
            <button
              className="btn btn-secondary"
              style={{ marginTop: 8, fontSize: 11, padding: '5px 10px' }}
              onClick={() => navigator.clipboard.writeText(agentToken)}
            >
              📋 Copiar
            </button>
          </div>
        )}
      </div>

      {/* Info */}
      <div className="card" style={{ maxWidth: 600, marginTop: 20 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>ℹ️ Cómo instalar el agente</h3>
        <ol style={{ fontSize: 12, color: 'var(--text2)', lineHeight: 2, paddingLeft: 16 }}>
          <li>Descarga el instalador <strong>AccioTrack-Setup.exe</strong></li>
          <li>Instálalo en el equipo del empleado</li>
          <li>Al abrirlo por primera vez, introduce el email y contraseña <strong>o</strong> el token generado aquí</li>
          <li>El agente arrancará automáticamente con Windows y quedará en la bandeja del sistema</li>
          <li>El empleado podrá fichar entrada/salida desde el icono de la bandeja</li>
        </ol>
      </div>
    </div>
  );
}
